export default __webpack_public_path__ + "static/media/vlado.aad042a7.jpg";